import styled, { css } from 'styled-components'

export const Root = styled.div<{ $empty?: boolean }>(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${theme.colors.gray100};
    overflow: hidden;
  `,
)

export const ContentContainer = styled.main(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    gap: ${theme.space['16']};
    padding: ${theme.space['16']} ${theme.space['40']} ${theme.space['40']};
    overflow: hidden;
    user-select: none;
  `,
)

export const ErrorContainer = styled.div(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    & > [data-component-id='Alert'] {
      align-self: center;
    }
  `,
)

export const ScreenOrientationContainer = styled.div(
  ({ theme }) => css`
    display: grid;
    place-content: center;
    justify-items: center;
    height: 100%;
    text-align: center;

    & > *:nth-child(2) {
      margin: ${theme.space['32']} ${theme.space['0']} ${theme.space['8']};
    }
  `,
)

export const RotateDeviceImg = styled.img(
  () => css`
    max-width: 13.4rem;
  `,
)
